module.exports = __webpack_public_path__ + "img/five.d27b13ab.jpeg";